export default __webpack_public_path__ + "static/media/onboarding-photo.c4af33c2.svg";